import { Button, Input, Select } from "antd";
import React from "react";
import NumberFormat from "react-number-format";
import { numberMask } from "../../../../services/helpersMethodsService";
import { Card } from "../../../utils/picketCardList/styles";

const MAX_QUANTITY = 10000;

function formatMinutes(minutes) {
  if (!minutes) return "-";
  const hour = String(Math.floor(minutes / 60)).padStart(2, "0");
  const min = String(minutes % 60).padStart(2, "0");
  return `${hour}:${min}`;
}

// Cartão de fornecimento de um piquete (equivalente a uma linha da tabela).
// `form` é translation.picketSupplementSupply.form
const PicketSupplyCard = ({
  picket,
  form,
  placeholder,
  selectPlaceholder,
  showStats,
  allSupplements,
  isLoadingSupplements,
  onFieldChange,
  onSupplementChange,
}) => (
  <Card>
    <div className="cardHeader">
      <div>
        <div className="cardTitle">{picket.picketName}</div>
        <div className="cardSubtitle">{picket.lotName}</div>
      </div>
      <div className="cardSubtitle">
        {form.tableSupplies.animalsCount}: <strong>{picket.animalsCount}</strong>
      </div>
    </div>
    <div className="cardInfo">
      {showStats && (
        <>
          <span>
            {form.tableSupplies.avgWeight}:{" "}
            <strong>{numberMask(picket.avgWeight || 0, false)}</strong>
          </span>
          <span>
            {form.tableSupplies.avgGdp}:{" "}
            <strong>{numberMask(picket.avgGdp || 0, false)}</strong>
          </span>
        </>
      )}
      <span>
        {form.tableSupplies.dryMatterPercentage}:{" "}
        <strong>{`${numberMask(picket.dryMatterPercentage || 0, false)}%MS`}</strong>
      </span>
      <span>
        {form.tableSupplies.prevSuppliedPerAnimal}:{" "}
        <strong>{`${numberMask(picket.prevSuppliedPerAnimal || 0, false)}kg`}</strong>
      </span>
      <span>
        {form.tableSupplies.prevSuppliedDryMatterByWeight}:{" "}
        <strong>{`${numberMask(
          picket.prevSuppliedDryMatterByWeight || 0,
          false,
        )}%`}</strong>
      </span>
      <span>
        {form.tableSupplies.prevSupplyHourInMinutes}:{" "}
        <strong>{formatMinutes(picket.prevSupplyHourInMinutes)}</strong>
      </span>
    </div>
    <div className="cardGrid">
      <div className="cardField fullWidth">
        <label>{form.tableSupplies.supplementId}</label>
        <Select
          value={picket.supplementId || undefined}
          loading={isLoadingSupplements}
          allowClear
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
          placeholder={selectPlaceholder}
          onChange={onSupplementChange}
        >
          {allSupplements.map((supplement) => (
            <Select.Option key={supplement.id} value={supplement.id}>
              {supplement.name}
            </Select.Option>
          ))}
        </Select>
      </div>
      <div className="cardField">
        <label>
          {form.tableSupplies.quantitySupplied} ({form.current})
        </label>
        <NumberFormat
          customInput={Input}
          value={picket.quantitySupplied || ""}
          inputMode="decimal"
          decimalScale={2}
          placeholder={placeholder}
          addonAfter="Kg"
          decimalSeparator=","
          thousandSeparator="."
          fixedDecimalScale={true}
          onValueChange={({ floatValue }) =>
            onFieldChange(
              "quantitySupplied",
              floatValue
                ? floatValue > MAX_QUANTITY
                  ? MAX_QUANTITY
                  : floatValue
                : null,
            )
          }
        />
      </div>
      <div className="cardField">
        <label>
          {form.tableSupplies.quantitySupplied} ({form.previous})
        </label>
        <NumberFormat
          customInput={Input}
          value={picket.previousQuantitySupplied || ""}
          disabled
          decimalScale={2}
          placeholder={placeholder}
          addonAfter="Kg"
          decimalSeparator=","
          thousandSeparator="."
          fixedDecimalScale={true}
        />
      </div>
      {picket.previousQuantitySupplied && (
        <div className="cardField fullWidth">
          <Button
            block
            type="dashed"
            icon="swap"
            onClick={() =>
              onFieldChange(
                "quantitySupplied",
                picket.previousQuantitySupplied,
              )
            }
          >
            {form.applyPreviousValue}
          </Button>
        </div>
      )}
      <div className="cardField">
        <label>{form.tableSupplies.supplyHourInMinutes}</label>
        <Input
          type="time"
          step={60}
          value={picket.supplyHourInMinutes || undefined}
          onChange={(e) => onFieldChange("supplyHourInMinutes", e.target.value)}
        />
      </div>
      <div className="cardField">
        <label>{form.tableSupplies.observation}</label>
        <Input
          value={picket.observation || ""}
          placeholder={placeholder}
          onChange={(e) => onFieldChange("observation", e.target.value)}
        />
      </div>
    </div>
  </Card>
);

export default PicketSupplyCard;
